import { useEffect, useContext } from "react";
import Context from "../../storage/context";

const css = `
@import url('https://fonts.googleapis.com/css2?family=Heebo:wght@300;400;500;600;700;800;900&display=swap');

.ab-section {
  background: #050d1a;
  padding: 80px 24px;
  direction: rtl;
  font-family: 'Heebo', sans-serif;
  position: relative;
  overflow: hidden;
}

/* bg glow */
.ab-section::before {
  content: '';
  position: absolute;
  top: -100px; right: -150px;
  width: 500px; height: 500px;
  background: radial-gradient(circle, rgba(201,168,76,.05) 0%, transparent 70%);
  pointer-events: none;
}
.ab-section::after {
  content: '';
  position: absolute;
  bottom: -100px; left: -150px;
  width: 400px; height: 400px;
  background: radial-gradient(circle, rgba(201,168,76,.04) 0%, transparent 70%);
  pointer-events: none;
}

.ab-inner {
  max-width: 1000px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
}

/* ── HEADER ── */
.ab-header { text-align: center; margin-bottom: 60px; }
.ab-tag {
  display: inline-flex; align-items: center; gap: 8px;
  font-size: 11px; font-weight: 700; color: #c9a84c;
  letter-spacing: 2.5px; text-transform: uppercase; margin-bottom: 14px;
}
.ab-tag::before, .ab-tag::after {
  content: ''; width: 28px; height: 1px; background: #c9a84c; opacity: .45;
}
.ab-title {
  font-size: clamp(28px, 4vw, 40px);
  font-weight: 900; color: #edf0f5;
  line-height: 1.2; margin-bottom: 16px;
}
.ab-title span {
  background: linear-gradient(135deg, #c9a84c, #e4c97e);
  -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text;
}
.ab-sub {
  font-size: 16px; color: #8da0b8; font-weight: 400;
  line-height: 1.7; max-width: 580px; margin: 0 auto;
}

/* ── MAIN LAYOUT ── */
.ab-layout {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
  align-items: start;
  margin-bottom: 48px;
}

/* ── STORY CARD ── */
.ab-story {
  background: #0b1622;
  border: 1px solid rgba(255,255,255,.06);
  border-radius: 20px;
  padding: 36px 32px;
  position: relative;
  overflow: hidden;
}
.ab-story::before {
  content: '"';
  position: absolute; top: 12px; left: 20px;
  font-size: 120px; font-weight: 900;
  color: rgba(201,168,76,.06); line-height: 1;
  font-family: Georgia, serif;
}
.ab-story__title {
  font-size: 18px; font-weight: 800; color: #edf0f5;
  margin-bottom: 16px;
  display: flex; align-items: center; gap: 10px;
}
.ab-story__title::before {
  content: ''; width: 3px; height: 20px;
  background: linear-gradient(180deg, #c9a84c, #a87c2a);
  border-radius: 2px; flex-shrink: 0;
}
.ab-story__text {
  font-size: 14px; color: #8da0b8; line-height: 1.85;
  font-weight: 400;
}
.ab-story__text p + p { margin-top: 14px; }

/* ── STATS COLUMN ── */
.ab-stats { display: flex; flex-direction: column; gap: 16px; }
.ab-stat {
  background: #0b1622;
  border: 1px solid rgba(255,255,255,.06);
  border-radius: 16px; padding: 22px 24px;
  display: flex; align-items: center; gap: 18px;
  transition: border-color .25s, transform .25s, box-shadow .25s;
  position: relative; overflow: hidden;
}
.ab-stat::after {
  content: '';
  position: absolute; left: 0; top: 0; bottom: 0;
  width: 3px;
  background: linear-gradient(180deg, #c9a84c, rgba(201,168,76,.2));
  border-radius: 0 2px 2px 0;
}
.ab-stat:hover {
  border-color: rgba(201,168,76,.25);
  transform: translateX(-4px);
  box-shadow: 0 8px 30px rgba(0,0,0,.3);
}
.ab-stat__ico {
  width: 50px; height: 50px; border-radius: 13px; flex-shrink: 0;
  background: rgba(201,168,76,.1); border: 1px solid rgba(201,168,76,.2);
  display: flex; align-items: center; justify-content: center; font-size: 22px;
}
.ab-stat__num {
  font-size: 28px; font-weight: 900; color: #edf0f5;
  line-height: 1;
  background: linear-gradient(135deg, #fff, #e4c97e);
  -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text;
}
.ab-stat__lbl { font-size: 13px; color: #8da0b8; font-weight: 500; margin-top: 3px; }

/* ── VALUES ROW ── */
.ab-values {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
}
.ab-val {
  background: #0b1622;
  border: 1px solid rgba(255,255,255,.06);
  border-radius: 16px; padding: 24px 20px;
  text-align: center;
  transition: border-color .25s, transform .25s;
}
.ab-val:hover {
  border-color: rgba(201,168,76,.25);
  transform: translateY(-3px);
}
.ab-val__ico { font-size: 28px; margin-bottom: 12px; }
.ab-val__title { font-size: 15px; font-weight: 800; color: #edf0f5; margin-bottom: 8px; }
.ab-val__text { font-size: 13px; color: #4d6073; line-height: 1.6; }

/* ── GOLD DIVIDER ── */
.ab-divider {
  display: flex; align-items: center; gap: 16px;
  margin: 48px 0;
}
.ab-divider__line { flex: 1; height: 1px; background: rgba(255,255,255,.06); }
.ab-divider__diamond {
  width: 8px; height: 8px;
  background: #c9a84c; transform: rotate(45deg);
  box-shadow: 0 0 8px rgba(201,168,76,.4);
}

@media (max-width: 700px) {
  .ab-layout { grid-template-columns: 1fr; gap: 20px; }
  .ab-values  { grid-template-columns: 1fr; }
  .ab-section { padding: 56px 16px; }
}
`;

export default function AboutSection() {



  return (
    <>
      <style>{css}</style>
      <section className="ab-section">
        <div className="ab-inner">

          {/* header */}
          <div className="ab-header">
            <div className="ab-tag">אודותינו</div>
            <h2 className="ab-title">הסיפור שלנו — <span>רועי קאר</span></h2>
            <p className="ab-sub">
              מעל עשור של ניסיון בשוק הרכב הישראלי, עם דגש על שקיפות, אמינות ושירות אישי
            </p>
          </div>

          {/* main layout */}
          <div className="ab-layout">

            {/* story */}
            <div className="ab-story">
              <div className="ab-story__title">הסיפור שלנו</div>
              <div className="ab-story__text">
                <p>
                  רועי קאר נוסדה מתוך אהבה אמיתית לרכב ומתוך רצון לשנות את חוויית רכישת הרכב
                  המשומש בישראל. הבנו שהרוכש הממוצע מרגיש לאבוד — מחירים לא שקופים,
                  מידע חלקי, ולחץ מיותר.
                </p>
                <p>
                  החלטנו לפעול אחרת. כל רכב אצלנו עובר בדיקה מקיפה, מוצג עם מלוא הפרטים,
                  ומתומחר בהגינות. אנחנו לא מוכרים רכב — אנחנו מוצאים לך את הרכב הנכון.
                </p>
                <p>
                  היום, אלפי לקוחות מרוצים לאורך הארץ הם ההוכחה הטובה ביותר לדרך שבחרנו.
                </p>
              </div>
            </div>

            {/* stats */}
            <div className="ab-stats">
              <div className="ab-stat">
                <div className="ab-stat__ico">🚗</div>
                <div>
                  <div className="ab-stat__num">500+</div>
                  <div className="ab-stat__lbl">רכבים נמכרו בהצלחה</div>
                </div>
              </div>
              <div className="ab-stat">
                <div className="ab-stat__ico">⭐</div>
                <div>
                  <div className="ab-stat__num">10+</div>
                  <div className="ab-stat__lbl">שנות ניסיון בתחום</div>
                </div>
              </div>
              <div className="ab-stat">
                <div className="ab-stat__ico">😊</div>
                <div>
                  <div className="ab-stat__num">98%</div>
                  <div className="ab-stat__lbl">לקוחות מרוצים</div>
                </div>
              </div>
              <div className="ab-stat">
                <div className="ab-stat__ico">🔍</div>
                <div>
                  <div className="ab-stat__num">100%</div>
                  <div className="ab-stat__lbl">שקיפות מלאה בכל עסקה</div>
                </div>
              </div>
            </div>
          </div>

          {/* divider */}
          <div className="ab-divider">
            <div className="ab-divider__line" />
            <div className="ab-divider__diamond" />
            <div className="ab-divider__line" />
          </div>

          {/* values */}
          <div className="ab-values">
            <div className="ab-val">
              <div className="ab-val__ico">🤝</div>
              <div className="ab-val__title">אמינות</div>
              <div className="ab-val__text">מידע מלא ושקוף על כל רכב — ללא הפתעות</div>
            </div>
            <div className="ab-val">
              <div className="ab-val__ico">🔧</div>
              <div className="ab-val__title">מקצועיות</div>
              <div className="ab-val__text">כל רכב עובר בדיקה מקיפה לפני המכירה</div>
            </div>
            <div className="ab-val">
              <div className="ab-val__ico">💛</div>
              <div className="ab-val__title">שירות אישי</div>
              <div className="ab-val__text">מלווים אותך לאורך כל תהליך הרכישה</div>
            </div>
          </div>

        </div>
      </section>
    </>
  );
}
